module.exports = __webpack_public_path__ + "static/media/polyu-speed-logo.95d5d467.png";